var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-message"},[_c('span',{staticClass:"error-icon"},[_c('icon',{attrs:{"name":"circle-alert"}})],1),_vm._v(" "),_c('span',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.error || _vm.$t('login.error.server-error')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }